export default __webpack_public_path__ + "static/media/banner.7c8f0e03.png";